import axios, {AxiosResponse} from 'axios';
import {ICmFilter, ICmService, ICmServiceCard, ICmServiceResponse, ISendReferrals} from '../cm-service/interfaces';
import {ILocation} from '../content/interfaces';

export const getCmFiltersApi = (): Promise<AxiosResponse<ICmFilter[]>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/cm/service/filters`);
};

export const getCmCountyFiltersApi = (regions: string): Promise<AxiosResponse<ICmFilter>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/cm/service/filter/counties/${regions}`);
};

export const getServicesApi = (filters: {
  filter: ICmFilter[],
  offset: number,
  limit: number
}): Promise<AxiosResponse<ICmServiceResponse>> => {
  return axios.post(`${process.env.REACT_APP_API_URL}/cm/service/filter`,
    filters);
};

export const getServiceApi = (srvId: number): Promise<AxiosResponse<ICmServiceCard>> => {
  return axios.get(`${process.env.REACT_APP_API_URL}/cm/service/${srvId}`);
};

export const addFavoriteApi = (srvId: number): Promise<AxiosResponse<{ value: string }>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/cm/service/favorite/add`,
    srvId.toString()
  );
};

export const removeFavoriteApi = (srvId: number): Promise<AxiosResponse<{ value: string }>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/cm/service/favorite/remove`,
    srvId.toString()
  );
};

export const getReferralsApi = (locale: string): Promise<AxiosResponse<ICmService[]>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/cm/service/referrals/list`,
    {
      params: {
        language: locale
      }
    }
  );
};

export const addReferralsApi = (data: {
  srvId: number,
  language: string,
  comments: string
}): Promise<AxiosResponse<{ value: string }>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/cm/service/referrals/add`,
    data
  );
};

export const removeReferralsApi = (contentIds: number[]): Promise<AxiosResponse<{ value: string }>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/cm/service/referrals/remove`,
    contentIds
  );
};

export const shareReferralsApi = (referrals: ISendReferrals): Promise<AxiosResponse<{ value: string }>> => {
  return axios.post(
    `${process.env.REACT_APP_API_URL}/cm/service/referrals/share`,
    referrals
  );
};

export const generateReferralHtmlTemplate = (templateId: number, serviceIds: number[]): Promise<AxiosResponse<{ value: string }>> => {
  return axios.get(
    `${process.env.REACT_APP_API_URL}/templates/referral/generate`,
    {
      params: {
        templateId,
        serviceIds: serviceIds.join(',')
      }
    }
  );
};
